import React from 'react';
import { useSelector } from 'react-redux';
import { CommonHeaderPropsWrapper } from 'core/type/header.types';
import { getShoppingCartBehavior } from 'core/utils/cart';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';
import { ActivitiesHeader } from 'component/common/Header/ActivitiesHeader';
import { LazyActivitiesHeader } from 'component/common/lazyCartActivity';

export const ActivitiesHeaderEntry: React.FC<CommonHeaderPropsWrapper> = React.memo((props) => {
    const config = useSelector(selectConfigFromBootstrap);

    const shouldUseCartContext = getShoppingCartBehavior(config);

    if (shouldUseCartContext) {
        return (
            <React.Suspense fallback={null}>
                <LazyActivitiesHeader {...props} />
            </React.Suspense>
        );
    }

    return <ActivitiesHeader {...props} />;
});
ActivitiesHeaderEntry.displayName = 'ActivitiesHeaderEntry';
